"use client";
import { Box, Flex, LinkBox, LinkOverlay, Text } from "@chakra-ui/react";
// import tagPng from "@/_images/png/Tag.png";
import { Post } from "@/_services/graphql/models/Posts";
import { NextLink } from "@/_components/ui/NextLink";
import { blogLinkBuilder } from "@/_utils";

interface BlogPostCardProps {
  post: Post;
  h?: string;
  isPublicBlog?: boolean;
}

export const BlogPostCard = ({
  post,
  h = "12rem",
  isPublicBlog = true,
}: BlogPostCardProps) => {
  return (
    <LinkBox as="article" w="full">
      <Flex
        color="white"
        bgImage={`url(${post.mainImage.asset.url})`}
        bgSize="cover"
        css={{ backgroundPosition: "center" }}
        rounded={{ base: "xl", md: "2xl" }}
        w="full"
        h={h}
        align="flex-end"
        pos="relative"
        transition="all 0.3s"
        _hover={{
          shadow: "shadow-xl",
          transform: "translateY(-5px)",
          border: "1px solid",
          borderColor: "primary.600",
        }}
        overflow="hidden"
        boxSizing="border-box"
      >
        <Box
          p={{ base: 2, md: 4 }}
          pb={{ base: 1, md: 3 }}
          roundedBottom={{ base: "xl", md: "2xl" }}
          w="full"
          boxSizing="border-box"
          backdropFilter="blur(1px)"
          bg="linear-gradient(0deg, rgba(63, 63, 63, 0.6), rgba(60, 60, 60, 0.5), rgba(185, 185, 185, .0));"
        >
          <LinkOverlay asChild>
            <NextLink
              href={blogLinkBuilder(
                post.slug?.current ?? "",
                isPublicBlog,
                post._id,
              )}
            >
              <Text
                color="white"
                textStyle="lg"
                fontFamily="beVietnamPro"
                fontWeight="base"
                letterSpacing="-0.05rem"
                lineHeight="1.3"
                mb={1}
                wordBreak="break-word"
                overflowWrap="break-word"
                css={{
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                }}
              >
                {post.title}
              </Text>
            </NextLink>
          </LinkOverlay>
        </Box>
      </Flex>
    </LinkBox>
  );
};
